module.exports = __webpack_public_path__ + "static/media/skin.8fcc0b7c.png";